import React from "react";
import { 
  Card, 
  CardContent, 
  Box, 
  Stack,
  Skeleton,
  useTheme
} from "@mui/material";

// BookingCardSkeleton component matching BookingCard structure
export default function BookingCardSkeleton() {
  const theme = useTheme();

  return (
    <Card
      sx={{
        maxWidth: 390,
        minWidth: 320,
        height: "100%",
        borderRadius: theme.shape.borderRadius * 1.5,
        border: `1px solid ${theme.palette.divider}`,
        p: { xs: 1, sm: 1.25 },
        pb: { xs: 1, sm: 1.25 },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* Room Image Skeleton */}
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height={{ xs: 180, sm: 228 }}
          sx={{ 
            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`
          }}
        />

        <CardContent sx={{ 
          p: 0, 
          pl: 1, 
          pt: 2.5,
          width: "100%", 
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}>
          {/* Top content: Title and Details */}
          <Box sx={{ flex: 1 }}>
            {/* Room Name Skeleton */}
            <Skeleton 
              variant="text" 
              width="70%" 
              height={32} 
              sx={{ mb: 2.5 }}
            />

            {/* Booking Details Skeleton */}
            <Stack spacing={1.5} sx={{ pl: 0.5, width: "100%", mb: 2.5 }}>
              {/* Date */}
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Skeleton variant="circular" width={24} height={24} sx={{ mt: 0.25 }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="80%" height={20} />
                </Box>
              </Stack>

              {/* Time */}
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Skeleton variant="circular" width={24} height={24} sx={{ mt: 0.25 }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="75%" height={20} />
                </Box>
              </Stack>

              {/* Meeting Name */}
              <Stack direction="row" spacing={1.5} alignItems="flex-start">
                <Skeleton variant="circular" width={24} height={24} sx={{ mt: 0.25 }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="85%" height={20} />
                </Box>
              </Stack>

              {/* Date Created */}
              <Box sx={{ pt: 1, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Skeleton variant="text" width="60%" height={16} />
              </Box>
            </Stack>
          </Box>

          {/* Bottom content: Action buttons */}
          <Stack 
            direction="row"  
            alignItems="center" 
            sx={{
              flexWrap: 'wrap',
              gap: 1,
              minHeight: 43,
            }}
          >
            <Skeleton 
              variant="rectangular" 
              width={80} 
              height={43}
              sx={{ 
                borderRadius: theme.shape.borderRadius * 0.5
              }}
            />
            
            <Skeleton 
              variant="rectangular" 
              width={193} 
              height={43}
              sx={{ 
                flex: '1 1 auto',
                maxWidth: 193,
                borderRadius: theme.shape.borderRadius * 0.5
              }}
            />
          </Stack>
        </CardContent>
      </Box>
    </Card>
  );
} 